export const TruckingMaterialPermissions = [
  {
    label: "Edit",
    name: "tmEdit",
  },
  {
    label: "View",
    name: "tmView",
  },
  {
    label: "Internal Approval",
    name: "tmInternalApproval",
  },
];

export const checkboxNames = {
  TM_EDIT: "tmEdit",
  TM_VIEW: "tmView",
  TM_INTERNAL_APPROVAL: "tmInternalApproval",
};

export const CRMSectionConsts = {
  arrowPosition: "right",
  borderedValue: false,
  OWNER_OPERATOR_LABEL: "Owner Operator",
  OWNER_OPERATOR_NAME: "ownerOperator",
  TRUCKING_MATERIAL_HEADER: "Trucking & Material",
  TRUCKING_MATERIAL_KEY: "tm",
};

export const getActiveKeys = (values) => {
  const activeKeys = Object.entries(values).reduce((keyList, [key, value]) => {
    if (Object.values(checkboxNames).includes(key)) {
      if (value) {
        if (key.includes(CRMSectionConsts.TRUCKING_MATERIAL_KEY)) {
          keyList.push(CRMSectionConsts.TRUCKING_MATERIAL_KEY);
        }
      }
    }
    return keyList;
  }, []);
  if (!!activeKeys.length) return [CRMSectionConsts.TRUCKING_MATERIAL_KEY];
  else return [];
};
